import { FC, ReactElement } from 'react'
import { Link } from 'react-router-dom'

import { ItemProps } from '../../types/footer'

import './item.css'

const Item: FC<ItemProps> = ({ subTitle, role }): ReactElement => {
  return (
    <div>
      {subTitle?.map((sub) => {
        return (
          <div className="item__subCategory" key={sub.title}>
            {role === 'help' ? (
              <a href={sub.url} aria-label={sub.title}>
                {sub.title}
              </a>
            ) : (
              <Link to={sub.url || ''} className="subCategory__link" role="link">
                {sub.title}
              </Link>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default Item
